// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import {FormHelperText, Input, InputLabel, Select, Stack, Tooltip} from "@mui/material";

// App Imports
import {addContractSection, editContractSection, getContractCS, updateCsTree} from "./ContractSectionClient";
import {changeCrudSnackbar} from "../CommonComponents/crudSnackbarSlice";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import {changeContractSection} from "./contractSectionSlice";
import {getAllDataPointValues} from "../DataPointValue/DataPointValueClient";
import {changeContractDataPoint} from "../ContractDataPoint/contractDataPointSlice";


// Main Function
export default function ContractSectionDrawer({fetchContractSections}) {


    // ****************** BEGIN STATES ****************************

    const [submitting, setSubmitting] = useState(true);
    const [showPreviousMenu, setShowPreviousMenu] = React.useState(true);

    const selectorContractGridAPI = useSelector((state) => state.contractSlc.value.contractGridAPI);
    const selectorParentId = useSelector((state) => state.contractDrilldownSlcCS.value.mousedParentSectionId);

    const selectorPreviousId = useSelector((state) => state.contractDrilldownSlcCS.value.mousedPreviousSectionId);
    const selectorContractId = useSelector((state) => state.contractSlc.value.id);
    const [parentDropdown, setParentDropdown] = useState([]);

    const [selectedParent, setSelectedParent] = useState(useSelector((state) => state.contractDrilldownSlcCS.value.mousedParentSectionId));
    const comboParent = selectorParentId !== undefined > 0 ? selectorParentId : selectedParent;


    const [typeDropdown, setTypeDropdown] = useState([]);
    const [selectedType, setSelectedType] = useState(useSelector((state) => state.contractDrilldownSlcCS.value.mousedType));



    const [previousDropdown, setPreviousDropdown] = useState([]);
    const [selectedPrevious, setSelectedPrevious] = useState(useSelector((state) => state.contractDrilldownSlcCS.value.mousedPreviousSectionId));
    const [selectedOrigin, setSelectedOrigin] = useState(null);

    // ****************** END STATES ****************************



    // ****************** BEGIN STORE ****************************

    const dispatchData = useDispatch() ;
    const selectorContractSectionId = useSelector((state) => state.contractDrilldownSlcCS.value.mousedId);
    const selectorCsDrawerState = useSelector((state) => state.contractSectionSlc.value.csDrawerState);
    const selectorCsDrawerMode = useSelector((state) => state.contractSectionSlc.value.csDrawerMode);
    const disableParentPrevious =  selectorCsDrawerMode === "Edit" ? true : false;


    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************

    const {register, handleSubmit} = useForm();

    // ****************** END REGISTER ****************************


    // ****************** BEGIN CRUD ****************************

    function onSubmit(data) {
        setSubmitting(true)
        // setContractSectionId(props.contractSectionIdX)
        console.log("here's my contractSection data before I submit it ")
        console.log({data})
        console.log("here's my parsed data minus parent and previous")
        console.log("selectedParent");
        console.log(selectedParent);
        console.log("comboParent");
        console.log(comboParent);
        console.log( selectorParentId === undefined || selectorParentId === null || selectorParentId === '' ? selectedParent : selectorParentId)


        if((selectorCsDrawerMode==="Add") ) {
            addContractSection(data)
                .then(() => {
                    console.log("Add With Parent and Previous ContractSection in payload");
                    console.log("selectedParent");
                    console.log(selectedParent);
                    console.log({data});
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                })
                .catch(err => {
                    console.log(err)
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
                })                .then(() => {
                updateCsTree().then(()=> dispatchData(changeContractSection({csDrawerState: false, csGridRefresh: true})))
            })
                .then(() =>{

                    dispatchData(changeContractSection({csDrawerState: false, csGridRefresh: true}))
                })
                .finally(() => {
                    setSubmitting(false);
                    dispatchData(changeContractSection({csGridRefresh: true}));
                    
                })
        }


        if((selectorCsDrawerMode==="Edit") ) {
            editContractSection(selectorContractSectionId,data)
                .then(() => {
                    console.log("With Parent and Previous ContractSection in payload");
                    console.log("selectedParent");
                    console.log(selectedParent);
                    console.log("This is the id being edited");
                    console.log(selectorContractSectionId);
                    console.log("This is the payload");
                    console.log({data});
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edit"}));
                })
                .catch(err => {
                    console.log(err)
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Edit failed"}));
                })
                .then(() =>{

                    dispatchData(changeContractSection({csDrawerState: false, csGridRefresh: true}))
                    console.log("Edit Successful?");
                })
                .finally(() => {
                    setSubmitting(false);
                    dispatchData(changeContractSection({csGridRefresh: true}));
                })
        }
    };

    // ****************** END CRUD ****************************





    // ****************** BEGIN MISC ****************************

    const onFinishFailed = errorInfo => {
        alert(JSON.stringify(errorInfo, null, 2));
    };

    function closeContractSectionDrawer() {
        // setShowContractSectionDrawer(false);
        dispatchData(changeContractSection({
            csDrawerState: false}));



    };

    // ****************** END MISC ****************************

    // *********************** BEGIN DROPDOWNS **************************

    let parentFilter = null;

    const fetchContractSectionsForParent = () =>
        getContractCS(selectorContractId)

            .then(data => {
                console.log(data);
                // setItems(data.sort((a, b) => a.name > b.name ? 1 : -1) );

                setParentDropdown(data)
            })
    useEffect(() => {
        console.log("This is for the dropdown2...");
        fetchContractSectionsForParent();
    }, []);


    const fetchContractSectionsForPrevious = () =>

        getContractCS(selectorContractId)

            .then(data => {
                console.log(data);

                if(parentFilter !== null && parentFilter !== ""){
                    setPreviousDropdown(data.filter(data => data.parentSectionId ===  parentFilter));
                    console.log("We're filtering for records with the same parent");
                    console.log("selectedParent = ", selectedParent);
                    console.log("selectorParentId = ", selectorParentId);
                    console.log("selectedPrevious = ", selectedPrevious);}
                else
                {setPreviousDropdown(data.filter(data => data.recordLevel ===  1));}

            })
            .then(() => console.log("selectedParent"))
            .then(() => console.log({selectedParent}))
            .then(() => {setShowPreviousMenu(false)}).then(() => {setShowPreviousMenu(true)})
            .then(() => {setShowPreviousMenu(false)}).then(() => {setShowPreviousMenu(true)})
    useEffect(() => {
        console.log("This is for the dropdown2...");
        fetchContractSectionsForPrevious()
            .then(() => {
                console.log("selectedParent")
                // dispatchData(changeContractSection({csDrawerState: false, csGridRefresh: true}))
            })
    }, []);

    const handleParentChange = (parentEvent) => {
        parentFilter = parentEvent.target.value;
        setSelectedParent(parentEvent.target.value);
        console.log("This is the selected Parent Section after change");
        console.log(parentEvent.target.value);
        console.log(selectedParent);
        fetchContractSectionsForPrevious()
            .then(() => {
                console.log("selectedParent")
                // dispatchData(changeContractSection({csDrawerState: false, csGridRefresh: true}))
            })
    };

    const handlePreviousChange = (previousEvent) => {
        setSelectedPrevious(previousEvent.target.value);
        console.log("This is the selected Previous Section after change");
        console.log(previousEvent.target.value);
    };




    const fetchDataPointValuesForDropdowns = () =>
        getAllDataPointValues()

            .then(data => {
                console.log(data);
                // setItems(data.sort((a, b) => a.name > b.name ? 1 : -1) );
                setTypeDropdown([
                    { id: '', name: '' },
                    ...data.filter(item => item.dataPointId === 12054)
                ]);
                // setTypeDropdown(data.filter(data => data.dataPointId ===  12054));
            })
    useEffect(() => {
        console.log("This is for the dropdown2...");
        fetchDataPointValuesForDropdowns();
    }, []);


    const handleTypeChange = (typeEvent) => {
        setSelectedType(typeEvent.target.value);
        dispatchData(changeContractSection({type: typeEvent.target.value}));
        console.log("This is for the selected Type");
        console.log(typeEvent.target.value);
    };


// *********************** END DROPDOWNS **************************



    // ****************** BEGIN FORM ****************************

    function contractSectionForm(){
        return(
            <form
                onSubmit={handleSubmit((data)=>        onSubmit(data))}
            >
                <Box
                    sx={{ width: 800 , height: 300, pl: 5}}
                    role="presentation"
                >
                    {selectorContractGridAPI !== "Dashboards" && <h2 style={ { paddingLeft: 0,
                        cursor:'pointer'}} onClick={() => closeContractSectionDrawer()}>Contract Section Form</h2>}
                    {selectorContractGridAPI === "Dashboards" && <h2 style={ { paddingLeft: 0,
                        cursor:'pointer'}} onClick={() => closeContractSectionDrawer()}>Dashboard Form</h2>}
                    <h4>{selectorCsDrawerMode} Mode</h4>
                    <Input
                        style={{ visibility: "hidden" }}
                        {...register('contract.id', { required: true })}
                        id="contract.id" name="contract.id"  label="Contract Id" aria-describedby="contractId_entry"
                        defaultValue=        {useSelector((state) => state.contractDrilldownSlcCS.value.mousedContractId)}
                    />

                    <br/>
                    <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}
                                 style={{ visibility: selectorCsDrawerMode === "Edit" ? "hidden" : "visible"}}>
                        <InputLabel htmlFor="parentSectionId">Parent Section</InputLabel>
                        <Select
                            {...register('parentSectionId', { required: false })}
                            labelId="demo-simple-select-filled-parent"
                            id="parentSectionId"

                            value= {selectorParentId === undefined || selectorParentId === null ? selectedParent : selectorParentId}
                            label="Parent Section"
                            onChange={handleParentChange}
                        >
                            {parentDropdown.map((parentItem) =>
                                <MenuItem
                                    value={parentItem.id}
                                    sx={{
                                        fontWeight: parentItem.recordLevel === 1 ? 'bold' : 'normal',
                                        pl: parentItem.recordLevel * 2 }}
                                >{parentItem.name}</MenuItem>
                            )}
                        </Select>
                        <FormHelperText id="value_helper">select the parent section this will go under</FormHelperText>
                    </FormControl>
                    {/*<br/>*/}
                    <br/>
                    {showPreviousMenu &&
                        <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}
                                     style={{ visibility: selectorCsDrawerMode === "Edit" ? "hidden" : "visible"}}>
                            <InputLabel  htmlFor="previousSectionId">Previous Section</InputLabel>
                            <Select
                                {...register('previousSectionId', { required: false })}
                                labelId="demo-simple-select-filled-label2"
                                id="previousSectionId"
                                label="Previous Section"
                                value= {selectorPreviousId === undefined || selectorPreviousId === null  ? selectedPrevious : selectorPreviousId}
                                // value=        {selectedPrevious}
                                onChange={handlePreviousChange}
                                defaultValue=        {selectedPrevious}
                            >
                                {previousDropdown.map((previousItem) =>
                                    <MenuItem value={previousItem.id}>{previousItem.name} - {previousItem.ordinalNumber}</MenuItem>
                                )}
                            </Select>
                            <FormHelperText id="origin_helper">select the section this will go after within the parent</FormHelperText>
                        </FormControl>}
                    {showPreviousMenu &&<br/>}

                    <br/>
                    <Stack spacing={6} direction="row" alignItems="center" >
                        <Box>
                    <InputLabel  htmlFor="mcode">Code</InputLabel>
                    <Input  sx={{ m: 1, minWidth: 200 }}
                            {...register('mcode', { required: true })}
                            id="mcode" name="mcode"  label="Mcode" aria-describedby="mcode_entry"
                            defaultValue=        {useSelector((state) => state.contractDrilldownSlcCS.value.mousedMcode)}
                    />
                    <FormHelperText id="mcode_helper">enter a brief identifier in all caps (e.g. "GENERAL")</FormHelperText>
                        </Box>
                        {/*<FormControl variant="standard" sx={{m: 1, minWidth: 200}}>*/}
                        {/*    <Tooltip enterDelay={1000}*/}
                        {/*             title={"Enter the type (optional)."}>*/}
                        {/*        <InputLabel htmlFor="type">Type</InputLabel>*/}
                        {/*    </Tooltip>*/}
                        {/*    <Select*/}
                        {/*        {...register('type', {required: true})}*/}
                        {/*        labelId="demo-simple-select-filled-type"*/}
                        {/*        id="type"*/}
                        {/*        label="type"*/}
                        {/*        sx={{width: 200}}*/}
                        {/*        onChange={handleTypeChange}*/}
                        {/*        value={useSelector((state) => state.contractSectionSlc.value.type)}*/}
                        {/*    >*/}
                        {/*        {TypeDropdown.map((TypeItem) => (*/}
                        {/*                <MenuItem*/}
                        {/*                    key={TypeItem.id}*/}
                        {/*                    value={TypeItem.name}*/}
                        {/*                >*/}
                        {/*                    <Tooltip*/}
                        {/*                        title={TypeItem.description || ""}*/}
                        {/*                        placement="right"*/}
                        {/*                        enterDelay={1000}*/}
                        {/*                    >*/}
                        {/*                        <span>{TypeItem.name}</span>*/}
                        {/*                    </Tooltip>*/}
                        {/*                </MenuItem>*/}
                        
                        {/*            )*/}
                        {/*        )}*/}
                        {/*    </Select>*/}
                        {/*    <FormHelperText id="type_helper">select the type (optional)</FormHelperText>*/}
                        {/*</FormControl>
                        */}
                        <FormControl variant="standard" sx={{ ml: 1, pr: 5, minWidth: 300 }} >
                            <InputLabel sx={{ ml: 1}} htmlFor="type">Type</InputLabel>
                            <Select
                                {...register('type', { required: false })}
                                labelId="demo-simple-select-filled-type"
                                id="type"
                                FreeSolo={true}
                                variant="standard"
                                label="type"
                                value={selectedType}
                                onChange={handleTypeChange}
                                sx={{ width: 300}}
                                // defaultValue=        {useSelector((state) => state.contractDrilldownSlcCS.value.mousedType)}
                            >
                                {typeDropdown.map((typeItem) =>
                                    <MenuItem  FreeSolo={true} value={typeItem.id}  key={typeItem.id}
                                    >{typeItem.name}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    </Stack>
                    {/*<br/>*/}
                    <br/>
                    <br/>
                    <InputLabel  htmlFor="name">Name</InputLabel>
                    <Input  sx={{ m: 1, minWidth: 500 }}
                            {...register('name', { required: true })}
                            id="name" name="name"  label="Name" aria-describedby="name_entry"
                            defaultValue=      {useSelector((state) => state.contractDrilldownSlcCS.value.mousedName)}
                    />
                    <FormHelperText id="name_helper">enter the name of the section</FormHelperText>
                    {/*<br/>*/}
                    <br/>
                    <br/>
                    <InputLabel  htmlFor="description">Description</InputLabel>
                    <Input  sx={{ m: 1, minWidth: 500 }}
                            {...register('description', { required: false })}
                            id="description" name="description"  label="Description" aria-describedby="description_entry"
                            defaultValue=        {useSelector((state) => state.contractDrilldownSlcCS.value.mousedDescription)}
                    />
                    <FormHelperText id="description_helper">enter a description</FormHelperText>
                    <HiddenFields />
                    <Button
                        type= "submit"
                    >Submit</Button>
                    <Button onClick={() => closeContractSectionDrawer()}>Cancel</Button>
                </Box>
            </form>
        );}

    // ****************** END FORM ****************************


    // ****************** BEGIN HIDDEN FIELDS ****************************

    function HiddenFields() {
        return (
            <div>
                <Input style={{ visibility: "hidden" }}
                       {...register('status', { required: false })}
                       id="status" name="status"  label="status" aria-describedby="status_entry"
                       defaultValue=        {useSelector((state) => state.contractDrilldownSlcCS.value.mousedStatus)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('hierarchy', { required: false })}
                       id="hierarchy" name="hierarchy"  label="hierarchy" aria-describedby="hierarchy_entry"
                       defaultValue=        {useSelector((state) => state.contractDrilldownSlcCS.value.mousedHierarchy)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('createdBy', { required: false })}
                       id="createdBy" name="createdBy"  label="createdBy" aria-describedby="createdBy_entry"
                       defaultValue=        {useSelector((state) => state.contractDrilldownSlcCS.value.mousedCreatedBy)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('lastModifiedBy', { required: false })}
                       id="lastModifiedBy" name="lastModifiedBy"  label="lastModifiedBy" aria-describedby="lastModifiedBy_entry"
                       defaultValue=        {useSelector((state) => state.contractDrilldownSlcCS.value.mousedLastModifiedBy)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('ordinalNumber', { required: false })}
                       id="ordinalNumber" name="ordinalNumber"  label="ordinalNumber" aria-describedby="ordinalNumber_entry"
                       defaultValue=        {useSelector((state) => state.contractDrilldownSlcCS.value.mousedOrdinalNumber)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('recordLevel', { required: false })}
                       id="recordLevel" name="recordLevel"  label="recordLevel" aria-describedby="recordLevel_entry"
                       defaultValue=        {useSelector((state) => state.contractDrilldownSlcCS.value.mousedRecordLevel)}
                />

                <Input style={{ visibility: "hidden" }}
                       {...register('partitionKey', { required: false })}
                       id="partitionKey" name="partitionKey"  label="partitionKey" aria-describedby="partitionKey_entry"
                       value= "Master"
                />
            </div>
        )}

    // ****************** END HIDDEN FIELDS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                anchor='right'
                open={selectorCsDrawerState}
                initialState={{open: false}}
                onClose={closeContractSectionDrawer}
            >
                {contractSectionForm()}
            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
